import { useQuery } from "@tanstack/react-query";
import { ApiGetUserCustodyInfo } from "@/api";
import type { GetUserCustodyInfoResponse } from "@/api/types";
import { getToken } from "@/lib/auth";

export function useGetUserCustodyInfo() {
  return useQuery({
    queryKey: ["userCustodyInfo"],
    queryFn: async (): Promise<GetUserCustodyInfoResponse> => {
      const res = await ApiGetUserCustodyInfo();
      console.log("ApiGetUserCustodyInfo", res);
      return res.data;
    },
    enabled: !!getToken(),
  });
}
